import React from 'react';
import {FlexRow} from '@forecast-it/design-system';
import {DeprecatedText as Text} from '@forecast-it/design-system';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';

const WrapperDiv = styled.div`
	margin-top: 25px;
	margin-bottom: 10px;
`;

const ProjectBudgetBreakdownHeader = () => {
	return (
		<WrapperDiv>
			<FlexRow alignItems={'flex-start'} gap={'l'}>
				<Text type={'heading'} variant={'l'}>
					<FormattedMessage id="program.project_budget_breakdown" />
				</Text>
			</FlexRow>
		</WrapperDiv>
	);
};

export default ProjectBudgetBreakdownHeader;
